import axios from 'axios';

class api {
    constructor() {
        //this._baseUrl = 'https://controllo-abbonamenti.bresciamobilita.it/api';
        this._baseUrl = process.env.NODE_ENV == 'production' ? 'https://controllo-abbonamenti.bresciamobilita.it/api' : 'https://localhost:5001/api';
        //this._baseUrl = '/api';
        this._instance = axios.create({
            //baseURL: '/api'
            baseURL: this._baseUrl
        });

        this._instance.interceptors.request.use(function (config) {
            const token = localStorage.getItem('token');            

            if (token != null) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        }, function (err) {
            return Promise.reject(err);
        });
    }

    newInstance() {
        return axios.create({
            baseURL: this._baseUrl
        });
    }

    get instance() {    
        return this._instance;
    }
}

export default new api();
    